import { render, staticRenderFns } from "./PastProjectsOne.vue?vue&type=template&id=3c04bb6a&scoped=true"
import script from "./PastProjectsOne.vue?vue&type=script&lang=js"
export * from "./PastProjectsOne.vue?vue&type=script&lang=js"
import style0 from "./PastProjectsOne.vue?vue&type=style&index=0&id=3c04bb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04bb6a",
  null
  
)

export default component.exports